import { Tabs as MUITabs, TabsProps as MuiTabsProps } from '@mui/material';
import {
  AB1, AB3, S1, S4,
} from '../../theme';
import Grid from '../Grid';
import { Spinner } from '../../animations';
import { mergeSX } from '../../services/helpers';
import { LeftArrowIcon, RightArrowIcon } from '../../icons';

export { default as Tab } from './components/Tab';

interface IBuildSXParams {
  minHeight?: number | string;
  marginRight?: number | string;
  padding?: number | string;
}

export interface ITabsProps extends MuiTabsProps, IBuildSXParams {
  isLoading?: boolean;
}

const buildSX = ({ minHeight, marginRight, padding }: IBuildSXParams) => ({
  minHeight,
  '&.MuiTabs-root': {
    position: 'relative',
    '& .MuiTab-root': {
      padding,
      marginRight,
      '&:last-of-type': {
        marginRight: 0,
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .Mui-selected': {
      background: AB1,
      borderRadius: '8px',
      color: AB3,
    },
    '& .MuiTabs-scrollButtons': {
      paddingLeft: '8px',
      paddingRight: '8px',
      background: S1,
      opacity: 1,
      '&:first-of-type': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        zIndex: 20,
      },
      '&.Mui-disabled': {
        zIndex: -1,
        opacity: 0,
      },
    },
    '& .MuiTouchRipple-root': {
      borderRadius: '8px',
    },
  },
});

const SLOTS = {
  StartScrollButtonIcon: () => <LeftArrowIcon color={S4} />,
  EndScrollButtonIcon: () => <RightArrowIcon color={S4} />,
};

const Tabs = (props: ITabsProps) => {
  const {
    children,
    minHeight = '38px',
    marginRight = '24px',
    padding = '8px 16px',
    isLoading = false,
    sx,
    ...restProps
  } = props;

  if (isLoading) {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ minHeight }}
      >
        <Spinner />
      </Grid>
    );
  }

  return (
    <MUITabs
      sx={mergeSX(buildSX({ minHeight, marginRight, padding }), sx)}
      variant="scrollable"
      scrollButtons="auto"
      slots={SLOTS}
      {...restProps}
    >
      {children}
    </MUITabs>
  );
};

export default Tabs;
